import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'bepatient-fixed-close-button',
  templateUrl: './fixed-close-button.component.html',
  styleUrls: ['./fixed-close-button.component.scss'],
  standalone: false
})
export class FixedCloseButtonComponent {
  @Input() color: string;
  @Output() buttonClicked = new EventEmitter();

  onClick() {
    this.buttonClicked.emit();
  }
}
